import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { 
  LayoutDashboard, 
  Tags, 
  Users, 
  Building2, 
  ShoppingCart, 
  Truck, 
  Package,
  Receipt,
  LogOut
} from 'lucide-react';
import './Sidebar.css';

const navItems = [
  { path: '/dashboard', label: 'Dashboard', icon: LayoutDashboard },
  { path: '/categorias', label: 'Categorias', icon: Tags },
  { path: '/clientes', label: 'Clientes', icon: Users },
  { path: '/centro-custos', label: 'Centro de Custos', icon: Building2 },
  { path: '/pedidos', label: 'Pedidos de Venda', icon: ShoppingCart },
  { path: '/fornecedores', label: 'Fornecedores', icon: Truck },
  { path: '/estoque', label: 'Estoque', icon: Package },
  { path: '/despesas', label: 'Despesas', icon: Receipt },
];

export default function Sidebar({ isOpen }) {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('userId');
    navigate('/login');
  };

  return (
    <aside className={`sidebar ${isOpen ? 'open' : 'closed'}`}>
      <div className="sidebar-header">
        <div className="logo-container">
          <div className="logo-icon">A</div>
          {isOpen && <h2 className="logo-text">Alefolia</h2>}
        </div>
      </div>
      
      <nav className="sidebar-nav">
        <div className="nav-section-title">{isOpen ? 'MENU PRINCIPAL' : '•••'}</div>
        <ul>
          {navItems.map((item) => {
            const Icon = item.icon;
            return (
              <li key={item.path}>
                <NavLink 
                  to={item.path} 
                  className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                  title={!isOpen ? item.label : undefined}
                >
                  <Icon className="nav-icon" size={20} />
                  {isOpen && <span className="nav-label">{item.label}</span>}
                </NavLink>
              </li>
            );
          })}
        </ul>
      </nav>
      
      <div className="sidebar-footer">
        <button onClick={handleLogout} className="nav-link logout-link" style={{ width: '100%', background: 'none', border: 'none', textAlign: 'left', cursor: 'pointer', fontFamily: 'inherit' }}>
          <LogOut className="nav-icon" size={20} />
          {isOpen && <span className="nav-label">Sair</span>}
        </button>
      </div>
    </aside>
  );
}
